import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dashboardComponent from '../../biz/dashboardBiz'

const initialState = {
    // list: {}, //for all properties used
    // draft: {}, //might need to use Array in the future for multiple drafts
    outdated: [],
    summary: {}, //previously aka propertyInfo //summary.total is totalActive property
    bestDeal: [],
}

// export const fetchAllPropState = createAsyncThunk('property/fetchAllPropState', async (agentId) => {
//     fetchOutdatedProperty(agentId)
//     fetchPropertySummary(agentId)
// })

export const fetchOutdatedProperty = createAsyncThunk('property/fetchOutdatedProperty', async (agentId) => {
    const outdatedProperties = await dashboardComponent.outdatedProperties(agentId)
    return outdatedProperties;
})

export const fetchPropertySummary = createAsyncThunk('property/fetchPropertySummary', async (agentId) => {
    const propertySummary = await dashboardComponent.summary(agentId)
    return propertySummary;
})

export const fetchBestDealProperty = createAsyncThunk('property/fetchBestDealProperty', async (agentId) => {
    const bestDealProperties = await dashboardComponent.bestDealProperties(agentId)
    return bestDealProperties;
})

export const fetchTrialSummary = createAsyncThunk('property/fetchTrialSummary', async (agentId) => {
    const trialSummary = await dashboardComponent.trialSummary(agentId)
    return trialSummary;
})

const propertySlice = createSlice({
    name: 'property',
    initialState,
    reducers: {
        // updateAll: (state, action) => {
        //     return
        // },
        // updatePropertyList: (state, action) => {
        //     return
        // },
        // // updatePropertyDraft: (state, action) => {
        // //     return 
        // // },
        // updateOutdatedProperty: (state, action) => {
        //     return
        // },
        // updatePropertySummary: (state, action) => {
        //     return
        // },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchOutdatedProperty.fulfilled, (state, action) => {
                state.outdated = action.payload
            })
            .addCase(fetchPropertySummary.fulfilled, (state, action) => {
                state.summary = action.payload
            })
            .addCase(fetchBestDealProperty.fulfilled, (state, action) => {
                state.bestDeal = action.payload
            })
            .addCase(fetchTrialSummary.fulfilled, (state, action) => {
                state.trialSummary = action.payload
            })
    }
})

// export const { updatePropertyList, updateOutdatedProperty, updatePropertySummary } = propertySlice.actions

export default propertySlice.reducer;